import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const transitionApi = createApi({
  reducerPath: "transitionApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Transitions"],
  endpoints: (builder) => ({
    // Get all transitions
    getTransitions: builder.query({
      query: () => "/transitions",
      transformResponse: (response) => response.data || response,
      providesTags: ["Transitions"],
    }),

    // Get a single Transition
    getTransitionById: builder.query({
      query: (id) => `/transitions/${id}`,
      transformResponse: (response) => response.data || response,
      providesTags: (result, error, id) => [{ type: "transitions", id }],
    }),

    // Create a new Transition
    createTransition: builder.mutation({
      query: (transition) => ({
        url: `/transitions`,
        method: "POST",
        body: transition,
      }),
      transformResponse: (response) => response.data || response,
      invalidatesTags: ["Transitions"],
    }),

    // Update an existing Transition
    updateTransition: builder.mutation({
      query: ({ id, ...transition }) => ({
        url: `/transitions/${id}`,
        method: "PUT",
        body: transition,
      }),
      invalidatesTags: ["Transitions"],
    }),

    // Delete an existing Transition
    deleteTransition: builder.mutation({
      query: (id) => ({
        url: `/transitions/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Transitions"],
    }),
  }),
});

export const {
  useGetTransitionsQuery,
  useGetTransitionByIdQuery,
  useCreateTransitionMutation,
  useUpdateTransitionMutation,
  useDeleteTransitionMutation,
} = transitionApi;
